import { NumericFormat, NumericFormatProps, NumberFormatValues } from 'react-number-format';
import { MAX_VALUE_SQUARE_FOOTAGE } from './constants';


interface SquareFootageNumberFormatterProps extends Omit<NumericFormatProps, 'onChange'> {
    inputRef: (instance: HTMLInputElement | null) => void;
    onChange: (event: { target: { name: string; value: number | '' } }) => void;
    name: string;
}

export interface InputBaseComponentProps extends React.HTMLAttributes<HTMLInputElement> {
    value?: unknown;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    name?: string;
    [key: string]: unknown;
}
export const SquareFootageNumberFormatter = (props: SquareFootageNumberFormatterProps) => {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values: NumberFormatValues) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value ? Number(values.value) : ''
                    }
                });
            }}
            thousandSeparator
            allowNegative={false}
            decimalScale={0}
            isAllowed={(values: NumberFormatValues) => {
                const { floatValue } = values;
                return !floatValue || (floatValue >= 0 && floatValue <= MAX_VALUE_SQUARE_FOOTAGE);
            }}
        />
    );
};